<div
  class="operation-inner"
  *ngFor="let operation of operationsFormArray.controls; let i = index; trackBy: trackByValue"
>
  <y42-operation-input-select-form-group
    class="contents"
    [form]="operation"
    [index]="i"
    [columnType]="columnType"
    [predefinedValues]="predefinedValues"
    [operatorOptions]="operatorOptions"
    (loadAutoProposal)="loadAutoProposal.emit()"
  ></y42-operation-input-select-form-group>
</div>
